module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f1sHP"))).then(() => parcelRequire('2KbAe'));